import React from 'react';
import { Quote, Star } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Testimonials() {
  const testimonials = [{
    quote: 'Pensé que tendría que esperar 7 años para comprar casa. En menos de 6 meses, Reinoso Business Consultant limpió mi historial y hoy mis hijos tienen su propio jardín. Fue la mejor inversión de mi vida.',
    author: 'Ricardo G.',
    role: 'Padre de Familia'
  }, {
    quote: 'Estaba cansada de que me negaran tarjetas de crédito en el supermercado. Ahora tengo un perfil sólido y pude sacar mi camioneta nueva con un interés bajísimo. Me devolvieron la confianza.',
    author: 'Elena M.',
    role: 'Usuaria Independiente'
  }];
  return <section className="py-24 lg:py-32 bg-white" data-id="element-174">
      <div className="max-w-7xl mx-auto px-6" data-id="element-175">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16" data-id="element-176">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-177">
              <div className="bg-brand-light p-10 rounded-3xl relative" data-id="element-178">
                <Quote size={48} className="text-brand-amber/20 absolute top-8 left-8" data-id="element-179" />
                <div className="relative z-10 pt-4" data-id="element-180">
                  <div className="flex gap-1 mb-6" data-id="element-181">
                    {[1, 2, 3, 4, 5].map(star => <Star key={star} size={20} className="fill-brand-amber text-brand-amber" data-id="element-182" />)}
                  </div>
                  <p className="text-xl md:text-2xl text-slate-700 font-medium leading-relaxed mb-8" data-id="element-183">
                    "{testimonial.quote}"
                  </p>
                  <div data-id="element-184">
                    <p className="font-bold text-slate-900 text-lg" data-id="element-185">
                      {testimonial.author}
                    </p>
                    <p className="text-slate-500" data-id="element-186">{testimonial.role}</p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}